export default "__VITE_ASSET__CnchD$Bg__"